import React from "react";
import "./sidebar.scss";
import { useNavigate } from "react-router-dom";

import BoxOne from "../component/boxes/box1/BoxOne.tsx";
import BoxTwo from "../component/boxes/box2/BoxTwo.tsx";
import BoxThree from "../component/boxes/box3/BoxThree.tsx";
import ColumnChart from "../component/boxes/chart/ChartColumn.tsx";
import CircularChartPaimentPerClass from "../component/boxes/chart/CircularChartPaimentPerClass.tsx";
import { API_ELEVE } from "../apiCaller/eleve.Caller.js";
import { accountService } from "../_services/accountServices.js";
import toast from "react-hot-toast";
import { EleveType, PaiementType, requestType } from "../types/GlobalType.ts";
import { API_PERSONNEL } from "../apiCaller/personnel.Caller.js";
import { API_PAIEMENT } from "../apiCaller/paiement.Caller.js";
import { API_DEPENSE } from "../apiCaller/depense.Caller.js";
import { paiementContext, depenseContext } from "../context/AppContext.js";
import { ANNEE_SCOLAIRE } from "../App.constants.js";
import { Skeleton } from "@mui/material";
import ConnexionErrorDiv from "../component/nodata/ConnexionErrorDiv.js";

function SideBar() {
  const [eleveData, setEleveData] = React.useState<EleveType[]>([]);
  const [personnelData, setpersonnelData] = React.useState([]);
  const [paiementData, setpaiementData] = React.useState<PaiementType[]>([]);
  const [depenseData, setdepenseData] = React.useState([]);

  const navigate = useNavigate();

  const [state, setState] = React.useState<requestType>({
    isLoading: true,
    errorMessage: false,
    successMessage: false,
  });

  const [stateEleve, setStateEleve] = React.useState<requestType>({
    isLoading: true,
    errorMessage: false,
    successMessage: false,
  });

  const [statePaiement, setStatePaiement] = React.useState<requestType>({
    isLoading: true,
    errorMessage: false,
    successMessage: false,
  });

  const fetchAllEleve = async () => {
    setStateEleve({
      isLoading: true,
      errorMessage: null,
      successMessage: null,
    });

    let token = accountService.getToken();
    if (!token) return navigate("/login");

    API_ELEVE.ELEVE.getAll(token)
      .then((response) => {
        // let axios_Fake_Response = {
        //   config: null,
        //   data: { data: [], message: "Situation Rapport is Empty" },
        //   status: 205,
        //   statusText: "OK",
        // };

        let empyData: EleveType[] = [];

        if (response.data === "") {
          setEleveData(empyData);
        } else {
          setEleveData(response.data.data);
        }
      })

      .catch((err) => {
        if (err.code === "ERR_NETWORK") {
          setStateEleve({
            ...state,
            errorMessage: "ERR_NETWORK",
          });
        } else if (err.response.status === 401) {
          setStateEleve({
            ...state,
            errorMessage: "Identifiant ou mot de passe incorrect",
          });
          toast.error("Votre session a expiré, veuillez vous reconnectez");
          accountService.logout();
          navigate("/", { replace: true });
        } else if (err.response.data.status === 406) {
          setStateEleve({
            ...state,
            errorMessage: "Adresse mail invalide",
          });
          return toast.error("Adresse mail invalide");
        } else {
          setStateEleve({
            ...state,
            errorMessage:
              "Une erreur inconnue est survenue, réessayer plus tard",
          });
          return toast.error(
            "Une erreur inconnue est survenue, réessayer plus tard"
          );
        }
      })
      .finally(() => {
        setStateEleve({
          isLoading: false,
          errorMessage: null,
          successMessage: null,
        });
      });
  };

  const fetchAllPersonnel = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();
    if (!token) return navigate("/login");

    API_PERSONNEL.PERSONNEL.getAll(token)
      .then((response) => {
        setState({
          isLoading: false,
          errorMessage: null,
          successMessage: null,
        });

        let empyData: any = [];

        if (response.data === "") {
          setpersonnelData(empyData);
        } else {
          setpersonnelData(response.data.data);
        }
      })
      .catch((err) => {
        setState({
          isLoading: false,
          successMessage: false,
          errorMessage: false,
        });

        if (err.code === "ERR_NETWORK") {
          setState({
            ...state,
            errorMessage: "ERR_NETWORK",
          });
        } else if (err.response.status === 401) {
          setState({
            ...state,
            errorMessage: "Identifiant ou mot de passe incorrect",
          });
          toast.error("Votre session a expiré, veuillez vous reconnectez");
          accountService.logout();
          navigate("/", { replace: true });
        } else if (err.response.data.status === 406) {
          setState({
            ...state,
            errorMessage: "Adresse mail invalide",
          });
          return toast.error("Adresse mail invalide");
        } else {
          setState({
            ...state,
            errorMessage:
              "Une erreur inconnue est survenue, réessayer plus tard",
          });
          return toast.error(
            "Une erreur inconnue est survenue, réessayer plus tard"
          );
        }
      });
  };

  const fetchAllPaiement = async () => {
    setStatePaiement({
      isLoading: true,
      errorMessage: null,
      successMessage: null,
    });

    let token = accountService.getToken();
    if (!token) return navigate("/login");

    API_PAIEMENT.PAIEMENT.getAll(token)
      .then((response) => {
        setStatePaiement({
          isLoading: false,
          errorMessage: null,
          successMessage: null,
        });

        let empyData: PaiementType[] = [];

        if (response.data === "") {
          setpaiementData(empyData);
        } else {
          setpaiementData(response.data.data);
        }
      })
      .catch((err) => {
        setStatePaiement({
          isLoading: false,
          successMessage: false,
          errorMessage: false,
        });

        if (err.code === "ERR_NETWORK") {
          setStatePaiement({
            ...state,
            errorMessage: "ERR_NETWORK",
          });
        } else if (err.response.status === 401) {
          setStatePaiement({
            ...state,
            errorMessage: "Identifiant ou mot de passe incorrect",
          });
          toast.error("Votre session a expiré, veuillez vous reconnectez");
          accountService.logout();
          navigate("/", { replace: true });
        } else if (err.response.data.status === 406) {
          setStatePaiement({
            ...state,
            errorMessage: "Adresse mail invalide",
          });
          return toast.error("Adresse mail invalide");
        } else {
          setStatePaiement({
            ...state,
            errorMessage:
              "Une erreur inconnue est survenue, réessayer plus tard",
          });
          return toast.error(
            "Une erreur inconnue est survenue, réessayer plus tard"
          );
        }
      });
  };

  const fetchAllDepense = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();
    if (!token) return navigate("/login");

    API_DEPENSE.DEPENSE.getAll(token)
      .then((response) => {
        setState({
          isLoading: false,
          errorMessage: null,
          successMessage: null,
        });

        let empyData: any = [];

        if (response.data === "") {
          setdepenseData(empyData);
        } else {
          setdepenseData(response.data.data);
        }
      })
      .catch((err) => {
        setState({
          isLoading: false,
          successMessage: false,
          errorMessage: false,
        });

        if (err.code === "ERR_NETWORK") {
          setState({
            ...state,
            errorMessage: "ERR_NETWORK",
          });
        } else if (err.response.status === 401) {
          setState({
            ...state,
            errorMessage: "Identifiant ou mot de passe incorrect",
          });
          toast.error("Votre session a expiré, veuillez vous reconnectez");
          accountService.logout();
          navigate("/", { replace: true });
        } else if (err.response.data.status === 406) {
          setState({
            ...state,
            errorMessage: "Adresse mail invalide",
          });
          return toast.error("Adresse mail invalide");
        } else {
          setState({
            ...state,
            errorMessage:
              "Une erreur inconnue est survenue, réessayer plus tard",
          });
          return toast.error(
            "Une erreur inconnue est survenue, réessayer plus tard"
          );
        }
      });
  };

  React.useEffect(() => {
    setTimeout(() => {
      fetchAllEleve();
      fetchAllPersonnel();
      fetchAllPaiement();
      fetchAllDepense();
    }, 2000);
  }, []);

  const skeletonBox = (
    <Skeleton
      variant="rounded"
      height={100}
      width={"100%"}
      // sx={{ marginTop: "5px", marginRight: "10px" }}
    />
  );

  return (
    <>
      {state.errorMessage === "ERR_NETWORK" ? (
        <ConnexionErrorDiv />
      ) : (
        <div className="dashboard">
          <div className="header_dash">
            <span>Dashboard</span>
          </div>
          <div className="home_dash">
            {stateEleve.isLoading ? (
              skeletonBox
            ) : (
              <div className="box box1">
                {/* for clients */}
                <BoxOne data={eleveData} />
              </div>
            )}

            {state.isLoading ? (
              skeletonBox
            ) : (
              <div className="box box3">
                {/* for all orders */}
                <BoxTwo data={personnelData} />
                {/* <CardThree isLoading={state.isLoading} /> */}
              </div>
            )}

            {statePaiement.isLoading ? (
              skeletonBox
            ) : (
              <div className="box box4">
                {/* for oders */}
                <BoxThree data={paiementData} />
                {/* <CardFour isLoading={state.isLoading} /> */}
              </div>
            )}

            <div className="box box2">
              {state.isLoading ? (
                skeletonBox
              ) : (
                <>
                  <div className="left_box">
                    <span>Chiksoft</span>
                    <span>Make perfect!</span>
                  </div>
                  <div className="right_box">
                    {" "}
                    <span>Année sc.</span>
                    <span>{ANNEE_SCOLAIRE[ANNEE_SCOLAIRE.length - 1]}</span>
                  </div>
                </>
              )}

              {/* <BoxFour /> */}
            </div>
            <div className="box box_graph1">
              {/* <ChartBox /> */}
              <paiementContext.Provider value={paiementData}>
                <depenseContext.Provider value={depenseData}>
                  <ColumnChart isLoading={statePaiement.isLoading} />
                </depenseContext.Provider>
              </paiementContext.Provider>
              {/* <ColumnChart isLoading={state.isLoading} /> */}
            </div>

            <div className="box box_graph2">
              <CircularChartPaimentPerClass
                data={eleveData}
                isLoading={state.isLoading}
              />
            </div>

            {/* <div className="box box_list">
        </div> */}
          </div>
        </div>
      )}
    </>
  );
}

export default SideBar;
